var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    opacity: 1,
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.2,
    stroke: "hsl(39.4,100%,93.7%)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: -2.5,
    transform: "rotate(45, 0, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: -2.5,
    transform: "rotate(45, 66.66666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: -2.5,
    transform: "rotate(45, 133.33333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: -2.5,
    transform: "rotate(45, 200, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: -2.5,
    transform: "rotate(45, 266.6666666666667, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: -2.5,
    transform: "rotate(45, 333.33333333333337, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: -2.5,
    transform: "rotate(45, 400.00000000000006, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: -2.5,
    transform: "rotate(45, 466.66666666666674, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: -2.5,
    transform: "rotate(45, 533.3333333333334, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: -2.5,
    transform: "rotate(45, 600, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: -2.5,
    transform: "rotate(45, 666.6666666666666, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: -2.5,
    transform: "rotate(45, 733.3333333333333, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: -2.5,
    transform: "rotate(45, 799.9999999999999, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 64.16666666666667,
    transform: "rotate(45, 0, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 64.16666666666667,
    transform: "rotate(45, 66.66666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 64.16666666666667,
    transform: "rotate(45, 133.33333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 64.16666666666667,
    transform: "rotate(45, 200, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 64.16666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 266.6666666666667, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 64.16666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 333.33333333333337, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 64.16666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 400.00000000000006, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 64.16666666666667,
    transform: "rotate(45, 466.66666666666674, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 64.16666666666667,
    transform: "rotate(45, 533.3333333333334, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 64.16666666666667,
    transform: "rotate(45, 600, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 64.16666666666667,
    transform: "rotate(45, 666.6666666666666, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 64.16666666666667,
    transform: "rotate(45, 733.3333333333333, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 64.16666666666667,
    transform: "rotate(45, 799.9999999999999, 66.66666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 130.83333333333334,
    transform: "rotate(45, 0, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 66.66666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 130.83333333333334,
    transform: "rotate(45, 133.33333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 200, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 266.6666666666667, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 130.83333333333334,
    transform: "rotate(45, 333.33333333333337, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 130.83333333333334,
    transform: "rotate(45, 400.00000000000006, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 130.83333333333334,
    transform: "rotate(45, 466.66666666666674, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 130.83333333333334,
    transform: "rotate(45, 533.3333333333334, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 600, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 666.6666666666666, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 130.83333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 733.3333333333333, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 130.83333333333334,
    transform: "rotate(45, 799.9999999999999, 133.33333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 197.5,
    transform: "rotate(45, 0, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 197.5,
    transform: "rotate(45, 66.66666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 197.5,
    transform: "rotate(45, 133.33333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 197.5,
    transform: "rotate(45, 200, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 197.5,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 266.6666666666667, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 197.5,
    transform: "rotate(45, 333.33333333333337, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 197.5,
    transform: "rotate(45, 400.00000000000006, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 197.5,
    transform: "rotate(45, 466.66666666666674, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 197.5,
    transform: "rotate(45, 533.3333333333334, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 197.5,
    transform: "rotate(45, 600, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 197.5,
    transform: "rotate(45, 666.6666666666666, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 197.5,
    transform: "rotate(45, 733.3333333333333, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 197.5,
    transform: "rotate(45, 799.9999999999999, 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 264.1666666666667,
    transform: "rotate(45, 0, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 264.1666666666667,
    transform: "rotate(45, 66.66666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 264.1666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 133.33333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 264.1666666666667,
    transform: "rotate(45, 200, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 264.1666666666667,
    transform: "rotate(45, 266.6666666666667, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 264.1666666666667,
    transform: "rotate(45, 333.33333333333337, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 264.1666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 400.00000000000006, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 264.1666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 466.66666666666674, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 264.1666666666667,
    transform: "rotate(45, 533.3333333333334, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 264.1666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 600, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 264.1666666666667,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 666.6666666666666, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 264.1666666666667,
    transform: "rotate(45, 733.3333333333333, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 264.1666666666667,
    transform: "rotate(45, 799.9999999999999, 266.6666666666667)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 330.83333333333337,
    transform: "rotate(45, 0, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 330.83333333333337,
    transform: "rotate(45, 66.66666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 330.83333333333337,
    transform: "rotate(45, 133.33333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 330.83333333333337,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 200, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 330.83333333333337,
    transform: "rotate(45, 266.6666666666667, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 330.83333333333337,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 333.33333333333337, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 330.83333333333337,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 400.00000000000006, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 330.83333333333337,
    transform: "rotate(45, 466.66666666666674, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 330.83333333333337,
    transform: "rotate(45, 533.3333333333334, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 330.83333333333337,
    transform: "rotate(45, 600, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 330.83333333333337,
    transform: "rotate(45, 666.6666666666666, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 330.83333333333337,
    transform: "rotate(45, 733.3333333333333, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 330.83333333333337,
    transform: "rotate(45, 799.9999999999999, 333.33333333333337)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 397.50000000000006,
    transform: "rotate(45, 0, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 397.50000000000006,
    transform: "rotate(45, 66.66666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 397.50000000000006,
    transform: "rotate(45, 133.33333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 397.50000000000006,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 200, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 397.50000000000006,
    transform: "rotate(45, 266.6666666666667, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 397.50000000000006,
    transform: "rotate(45, 333.33333333333337, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 397.50000000000006,
    transform: "rotate(45, 400.00000000000006, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 397.50000000000006,
    transform: "rotate(45, 466.66666666666674, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 397.50000000000006,
    transform: "rotate(45, 533.3333333333334, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 397.50000000000006,
    transform: "rotate(45, 600, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 397.50000000000006,
    transform: "rotate(45, 666.6666666666666, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 397.50000000000006,
    transform: "rotate(45, 733.3333333333333, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 397.50000000000006,
    transform: "rotate(45, 799.9999999999999, 400.00000000000006)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 464.16666666666674,
    transform: "rotate(45, 0, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 464.16666666666674,
    transform: "rotate(45, 66.66666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 464.16666666666674,
    transform: "rotate(45, 133.33333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 464.16666666666674,
    transform: "rotate(45, 200, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 464.16666666666674,
    transform: "rotate(45, 266.6666666666667, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 464.16666666666674,
    transform: "rotate(45, 333.33333333333337, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 464.16666666666674,
    transform: "rotate(45, 400.00000000000006, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 464.16666666666674,
    transform: "rotate(45, 466.66666666666674, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 464.16666666666674,
    transform: "rotate(45, 533.3333333333334, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 464.16666666666674,
    transform: "rotate(45, 600, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 464.16666666666674,
    transform: "rotate(45, 666.6666666666666, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 464.16666666666674,
    transform: "rotate(45, 733.3333333333333, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 464.16666666666674,
    transform: "rotate(45, 799.9999999999999, 466.66666666666674)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 530.8333333333334,
    transform: "rotate(45, 0, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 530.8333333333334,
    transform: "rotate(45, 66.66666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 530.8333333333334,
    transform: "rotate(45, 133.33333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 530.8333333333334,
    transform: "rotate(45, 200, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 530.8333333333334,
    transform: "rotate(45, 266.6666666666667, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 530.8333333333334,
    transform: "rotate(45, 333.33333333333337, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 530.8333333333334,
    transform: "rotate(45, 400.00000000000006, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 530.8333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 466.66666666666674, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 530.8333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 533.3333333333334, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 530.8333333333334,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 600, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 530.8333333333334,
    transform: "rotate(45, 666.6666666666666, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 530.8333333333334,
    transform: "rotate(45, 733.3333333333333, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 530.8333333333334,
    transform: "rotate(45, 799.9999999999999, 533.3333333333334)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 597.5,
    transform: "rotate(45, 0, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 597.5,
    transform: "rotate(45, 66.66666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 597.5,
    transform: "rotate(45, 133.33333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 597.5,
    transform: "rotate(45, 200, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 597.5,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 266.6666666666667, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 597.5,
    transform: "rotate(45, 333.33333333333337, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 597.5,
    transform: "rotate(45, 400.00000000000006, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 597.5,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 466.66666666666674, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 597.5,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 533.3333333333334, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 597.5,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 600, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 597.5,
    transform: "rotate(45, 666.6666666666666, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 597.5,
    transform: "rotate(45, 733.3333333333333, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 597.5,
    transform: "rotate(45, 799.9999999999999, 600)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 664.1666666666666,
    transform: "rotate(45, 0, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 664.1666666666666,
    transform: "rotate(45, 66.66666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 664.1666666666666,
    transform: "rotate(45, 133.33333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 664.1666666666666,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 200, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 664.1666666666666,
    transform: "rotate(45, 266.6666666666667, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 664.1666666666666,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 333.33333333333337, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 664.1666666666666,
    transform: "rotate(45, 400.00000000000006, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 664.1666666666666,
    transform: "rotate(45, 466.66666666666674, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 664.1666666666666,
    transform: "rotate(45, 533.3333333333334, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 664.1666666666666,
    transform: "rotate(45, 600, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 664.1666666666666,
    transform: "rotate(45, 666.6666666666666, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 664.1666666666666,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 733.3333333333333, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 664.1666666666666,
    transform: "rotate(45, 799.9999999999999, 666.6666666666666)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 730.8333333333333,
    transform: "rotate(45, 0, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 730.8333333333333,
    transform: "rotate(45, 66.66666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 730.8333333333333,
    transform: "rotate(45, 133.33333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 730.8333333333333,
    transform: "rotate(45, 200, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 730.8333333333333,
    transform: "rotate(45, 266.6666666666667, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 730.8333333333333,
    transform: "rotate(45, 333.33333333333337, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 730.8333333333333,
    transform: "rotate(45, 400.00000000000006, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 730.8333333333333,
    transform: "rotate(45, 466.66666666666674, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 730.8333333333333,
    transform: "rotate(45, 533.3333333333334, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 730.8333333333333,
    transform: "rotate(45, 600, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 730.8333333333333,
    fill: "hsl(39.4,100%,93.7%)",
    stroke: "none",
    transform: "rotate(45, 666.6666666666666, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 730.8333333333333,
    transform: "rotate(45, 733.3333333333333, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 730.8333333333333,
    transform: "rotate(45, 799.9999999999999, 733.3333333333333)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: -2.5,
    y: 797.4999999999999,
    transform: "rotate(45, 0, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 64.16666666666667,
    y: 797.4999999999999,
    transform: "rotate(45, 66.66666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 130.83333333333334,
    y: 797.4999999999999,
    transform: "rotate(45, 133.33333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 197.5,
    y: 797.4999999999999,
    transform: "rotate(45, 200, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 264.1666666666667,
    y: 797.4999999999999,
    transform: "rotate(45, 266.6666666666667, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 330.83333333333337,
    y: 797.4999999999999,
    transform: "rotate(45, 333.33333333333337, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 397.50000000000006,
    y: 797.4999999999999,
    transform: "rotate(45, 400.00000000000006, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 464.16666666666674,
    y: 797.4999999999999,
    transform: "rotate(45, 466.66666666666674, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 530.8333333333334,
    y: 797.4999999999999,
    transform: "rotate(45, 533.3333333333334, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 597.5,
    y: 797.4999999999999,
    transform: "rotate(45, 600, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 664.1666666666666,
    y: 797.4999999999999,
    transform: "rotate(45, 666.6666666666666, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 730.8333333333333,
    y: 797.4999999999999,
    transform: "rotate(45, 733.3333333333333, 799.9999999999999)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 797.4999999999999,
    y: 797.4999999999999,
    transform: "rotate(45, 799.9999999999999, 799.9999999999999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid2.363bc81dfea6584c117d41fc26ce79c4.svg";
export { ForwardRef as ReactComponent };